module.exports = __webpack_public_path__ + "static/media/photo.39caacc9.jpeg";